import ColumnPage from './ColumnPage';

export default function NewTheory() {
  return (
    <ColumnPage
      column="newtheory"
      title="NEW THEORY"
      description="Practical application of technology and systems thinking in everyday life. Nutrition, household systems, habit-building, resource management, and DIY experiments."
    />
  );
}
